/**
 * @generated SignedSource<<1d1ac9632c5837d14b5bcbec4f6da0a2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
export type ElementTypeV2 = "clozeText" | "file" | "multipleChoice" | "order" | "podcast" | "randomMultipleChoice" | "text" | "video" | "%future added value";
export type StructureType = "child" | "root" | "%future added value";
export type TypeDefinitionType = "branch" | "content" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type TreeContainer_TreeNodeFragment$data = {
  readonly hasBeenPublishedOnce: boolean;
  readonly id: string;
  readonly parentId: string | null | undefined;
  readonly structureDefinition: {
    readonly coordinates: {
      readonly parentRef: string | null | undefined;
    };
    readonly definitionType: StructureType;
    readonly title: string;
  };
  readonly typeDefinition: {
    readonly childRefs?: ReadonlyArray<string>;
    readonly definitionType: TypeDefinitionType;
    readonly elements?: ReadonlyArray<{
      readonly elementType: ElementTypeV2;
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"ElementNode_ElementV2Fragment">;
    }>;
  };
  readonly " $fragmentSpreads": FragmentRefs<"DeleteChildNodeButton_TreeNodeFragment" | "Node_TreeNodeFragment">;
  readonly " $fragmentType": "TreeContainer_TreeNodeFragment";
};
export type TreeContainer_TreeNodeFragment$key = {
  readonly " $data"?: TreeContainer_TreeNodeFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"TreeContainer_TreeNodeFragment">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "TreeContainer_TreeNodeFragment"
};

(node as any).hash = "27c35697af4051b9459a34c5ec800a24";

export default node;
